import React from 'react';
import { withTranslation } from 'react-i18next';
import CommonModal from '../../common/Modal';
import './index.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
import { REFERRAL_BONUS_PRICE } from '../../../constants/defaults';

const ReferralSignupSuccess = ({ closeDialogHandler, t, i18n }) => {
  return (
    <div className="successModalWrapper">
      <CommonModal
        closeDialogHandler={closeDialogHandler}
        closeButtonIMG="icon-close-white.svg"
      >
        <div className="sucessModalContainer">
          <p className="title">{t('You’re signed up!')}</p>
          <div className="savingsWrap">
            <p className="savingTitle">{t('Ready to start saving..')}</p>
            <ul className="savingDetails">
              <li className="steps">
                <LazyLoadImage
                  src="/content/images/homepagev2/step1.svg"
                  width="70px"
                  height="58px"
                  alt=""
                />
                <p className="steptitle">{t('Compare prices')}</p>
                <p className="description">{t('Find best deal')}</p>
              </li>
              <li className="steps">
                <LazyLoadImage
                  src="/content/images/homepagev2/step2.svg"
                  width="70px"
                  height="58px"
                  alt=""
                />
                <p className="steptitle">{t('Get free priscription')}</p>
                <p className="description">{t('Show to pharmacist')}</p>
              </li>
              <li className="steps">
                <LazyLoadImage
                  src="/content/images/homepagev2/step3.svg"
                  width="70px"
                  height="58px"
                  alt=""
                />
                <p className="steptitle">{t('Refer friend')}</p>
                <p className="description">
                  {t('Use referral link', { bonusPrice: REFERRAL_BONUS_PRICE })}
                </p>
              </li>
            </ul>
            <p className="bottomText">
              <span>{t('Still have questions?')} </span>
              <br className="mobile-only" />
              <span>
                {t('Visit our')}&nbsp;
                <a
                  href={_.withLocale(i18n.language, '/how-it-works')}
                  className="dialogComponent"
                >
                  {t('How it works')}
                </a>
                &nbsp;{t('page')}
              </span>
            </p>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default withTranslation()(ReferralSignupSuccess);
